export default "__VITE_ASSET__CaQnpm18__"